import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import SEO from "./SEO";
import "./CheckoutCancel.css";

export default function CheckoutCancel() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(8);

  // Auto-redirect to pricing after countdown
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/pricing", { replace: true });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="checkout-cancel-page">
      <SEO title="Checkout Cancelled" path="/checkout-cancel" description="Your checkout was cancelled." noIndex={true} />
      <Header />
      <div className="checkout-cancel-container">
        <div className="checkout-cancel-card">
          <div className="checkout-cancel-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <h1>Payment Cancelled</h1>
          <p className="checkout-cancel-message">
            Your payment was cancelled. No charges were made to your account.
          </p>

          <div className="checkout-cancel-info">
            <p className="checkout-cancel-info-text">
              Don't worry! You can still explore LawFusion and choose a plan whenever you're ready.
            </p>
            <ul className="checkout-cancel-benefits">
              <li>✓ Browse our pricing plans</li>
              <li>✓ Learn about our features</li>
              <li>✓ Start your free trial anytime</li>
            </ul>
          </div>

          <p className="checkout-cancel-submessage">
            Redirecting to pricing in {countdown} seconds...
          </p>

          <div className="checkout-cancel-actions">
            <button
              className="checkout-cancel-btn"
              onClick={() => navigate("/")}
            >
              Go to Home
            </button>
            <button
              className="checkout-cancel-btn-secondary"
              onClick={() => navigate("/pricing")}
            >
              View Pricing
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

